import { render, staticRenderFns } from "./table-datalog.component.vue?vue&type=template&id=5bd2e187&scoped=true&"
import script from "./table-datalog.component.vue?vue&type=script&lang=ts&"
export * from "./table-datalog.component.vue?vue&type=script&lang=ts&"
import style0 from "./table-datalog.component.vue?vue&type=style&index=0&id=5bd2e187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd2e187",
  null
  
)

export default component.exports